import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  AvatarGroup,
  Tooltip,
  IconButton
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  getUserId,
  getCurrentUser,
  deleteTeamFromFirestore
} from "../Helper";

function getRandomColor() {
  const colors = [
    "#FF5733", "#33FF57", "#3357FF", "#F4D03F",
    "#BB8FCE", "#5DADE2", "#48C9B0", "#F1948A"
  ];
  return colors[Math.floor(Math.random() * colors.length)];
}

export default function OtherTeamSubmissions({
  teams: initialTeams,
  clubId,
  projectId,
  isCurrentUserAdmin
}) {
  const userId = getUserId();
  const userData = getCurrentUser();
  const [teams, setTeams] = useState(initialTeams);

  const handleDelete = async (team) => {
    if (!clubId || !projectId) {
      console.error("Missing clubId or projectId");
      return;
    }

    const teamName = team.name;
    const teamMembers = team.members;

    try {
      await deleteTeamFromFirestore(clubId, projectId, teamName, teamMembers);

      // Update local state to remove deleted team
      setTeams(prev => prev.filter(t =>
        !(t.name === teamName && JSON.stringify(t.members) === JSON.stringify(teamMembers))
      ));
    } catch (error) {
      console.error("Error deleting team:", error);
    }
  };

  return (
    <>
    
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="h6" fontWeight="bold" textAlign="center">
        Teams
      </Typography>

      <Card variant="outlined">
        <CardContent>
          {teams.map((team, index) => (
            <Box
              display="flex"
              key={index}
              alignItems="center"
              justifyContent="space-between"
              gap={2}
              mb={2}
            >
              {/* Team Info */}
              <Box display="flex" alignItems="center" gap={2}>
                <Typography variant="h6" fontWeight="bold">
                  {team.name}
                </Typography>

                {/* Members as Avatars */}
                <AvatarGroup max={4}>
                  {team.members.map((member, idx) => (
                    <Tooltip
                      key={idx}
                      title={member?.name ?? member?.otherData?.id}
                    >
                      <Avatar sx={{ bgcolor: getRandomColor() }}>
                        {member?.name
                          ? member.name.charAt(0)
                          : member?.otherData?.id?.charAt(0)}
                      </Avatar>
                    </Tooltip>
                  ))}
                </AvatarGroup>
              </Box>

              {/* Delete Button */}
              {isCurrentUserAdmin === true ? (
              <IconButton
                aria-label="delete"
                color="error"
                onClick={() => handleDelete(team)}
              >
                <DeleteIcon />
              </IconButton>
              ) : null}
            </Box>
          ))}
        </CardContent>
      </Card>
    </Box>
    
    </>
  );
}
